export interface BrowserInfo {
  colorDepth: number;
  javaEnabled: boolean;
  javaScriptEnabled: boolean;
  language: string;
  screenHeight: number;
  screenWidth: number;
  timeZoneOffset: number;
}
